'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import BenchmarkTemplateStyle from './style';
const HeroSection = dynamic(() => import('@/modules/BusinessEnvironment/Incentives/individual/components/HeroSection'));

const List = dynamic(() => import('../components/List'));

const BenchmarkTemplate = ({ pageData, countriesData, chartsData }) => {
	return (
		<BenchmarkTemplateStyle>
			<HeroSection
				isArrows={false}
				external_title={pageData.title}
				external_description={pageData.description}
				external_desktop_image={pageData.desktop_image}
				external_mobile_image={pageData.mobile_image}
			/>

			<List
				chartsData={chartsData}
				countriesData={countriesData}
			/>
		</BenchmarkTemplateStyle>
	);
};

export default BenchmarkTemplate;
